module.exports = __webpack_public_path__ + "img/Fieldkit_Panel 01_Final_no_overlays_sized.8eac2868.jpg";